import { fetch } from '../config/axios'

// 首页数据
export function indexInfo (params) {
  return fetch(params, '/indexInfo')
}

// 精选专区
export function boutiqueList (params) {
  return fetch(params, '/boutiqueList')
}
// 拼多多精选专区
export function boutiquePddList (params) {
  return fetch(params, '/boutiquePddList')
}
// 拼多多搜索榜单
export function pinduoduoGetrecommend (params) {
  return fetch(params, '/pinduoduoGetrecommend')
}
// 拼多多推送接口
export function pinduoduoWHPush (params) {
  return fetch(params, '/pinduoduoWHPush', true)
}
// 搜索记录、热门
export function keywordList (params) {
  return fetch(params, '/keywordList')
}

// 清空搜索记录
export function clearHistoryList (params) {
  return fetch(params, '/clearHistoryList')
}
// 搜索结果
export function searchList (params) {
  return fetch(params, '/searchList')
}
export function searchListV1 (params) {
  return fetch(params, '/v1/searchList')
}
// top100
export function topProductList (params) {
  return fetch(params, '/topProductList')
}

// 淘客一级分类
export function findAmoyCategory (params) {
  return fetch(params, '/findAmoyCategory')
}
// 淘客二级分类
export function findAmoyEjCategory (params) {
  return fetch(params, '/findAmoyEjCategory')
}

// 淘客一二级分类商品列表
export function findAmoyProductListByCategory (params) {
  return fetch(params, '/findAmoyProductListByCategory')
}
// 抖券
export function getTrillData (params) {
  return fetch(params, '/getTrillData')
}
// 折淘客商品详情（包含云超，天猫，聚划算）
export function zetaokeDetail (params) {
  return fetch(params, '/zetaokeDetail')
}
// 获取拼多多商品推广链接API
export function getpdditemtgurl (params) {
  return fetch(params, '/getpdditemtgurl', true)
}
// 获取京东商品推广链接API
export function doItemCpsUrl (params) {
  return fetch(params, '/doItemCpsUrl', true)
}
// 多多客生成频道推广链接
export function DuoduoRouter (params) {
  return fetch(params, '/DuoduoRouter', true)
}
// 折淘客高佣转链API接口
export function gaoyongzhuanlian (params) {
  return fetch(params, '/gaoyongzhuanlian',true)
}
// 拼多多详情
export function pinduoduoProductDetail (params) {
  return fetch(params, '/pinduoduoProductDetail')
}
// 京东详情
export function jdProductDetail (params) {
  return fetch(params, '/v1/jdDetail')
}



// WEBPACK FOOTER //
// ./src/api/home.js